import React from 'react';
import StraightenIcon from '@mui/icons-material/Straighten';

import { useAppMonitor } from '../../../monitor';
import { isLayoutViewActive } from '../../../store/selectors/layoutModeSelectors';
import { setDimensionMode } from '../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { DimensionModeToolbarButtons } from '../top/DimensionModeToolbarButtons';
import { LayoutDimensionModeToolbarButtons } from '../top/LayoutDimensionModeToolbarButtons';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function UserDimensionsButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const inLayoutMode = useAppSelector(isLayoutViewActive);
  const inDimensionMode = useAppSelector((state) => state.application.inDimensionMode);

  return (
    <>
      <ToolbarIconButton
        icon={<StraightenIcon />}
        title="Dimension Mode (Ctrl + D)"
        color={inDimensionMode ? 'secondary' : 'default'}
        sx={inDimensionMode ? { backgroundColor: 'rgba(77, 147, 120, 0.6)!important' } : undefined}
        onClick={() => {
          dispatch(setDimensionMode(!inDimensionMode));
          monitor.recordInteraction('Dimension Mode Activated');
        }}
      />

      {inDimensionMode && (inLayoutMode ? <LayoutDimensionModeToolbarButtons /> : <DimensionModeToolbarButtons />)}
    </>
  );
}
